
const initState = () => ({
})

export const state = initState

export const getters = {
}

export const mutations = {

}

export const actions = {

  async getSmsPreview({}, smsInitialData){
    let smsContentText = null
    try{
      const result = await this.$axios.$get(`/webpos/sms/preview?${new URLSearchParams(smsInitialData).toString()}`);
      if(!result || result?.apiMessages.hasErrors) {
        this.$toast.error('Error while generating sms preview');
      }
      else{
        smsContentText = result.value;
      }
    }
    catch(e){
      console.error('Error while getting the SMS preview', e);
      this.$toast.error('Error while getting the SMS preview')
    }
    return smsContentText;
  },

  async queueSms({commit, state}, smsToSend){
    try{
      const result = await this.$axios.$post(`/webpos/sms/queue`, smsToSend)
      if(result && !result.hasErrors) {
        this.$toast.success("The SMS has been processed and will be sent shortly.")
        return true
      }
      else{
        this.$toast.error('Error while sending SMS');
        return false
      }
    }
    catch(e){
      console.error('Error while sending SMS', e);
      this.$toast.error('Error while sending SMS')
      return false
    }
  }
}
